import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import journeysQueryKeys from "./keys";
import TestJourneyService from "../services";
import { JOURNEY_STATUS } from "constants/journey";

export const useJourneysList = ({ projectId, page, limit, searchQuery, sortConfig}) => {
    return useQuery({
        queryKey: [journeysQueryKeys.journeyList, projectId, page, limit, searchQuery, sortConfig],
        queryFn: () => TestJourneyService.getAllJourneys({ projectId, page, limit, searchQuery, sortConfig }),
        enabled: !!projectId,
        placeholderData: (prev) => prev,
    });
}

export const useDeleteJourneysMutation = ({ projectId, idsToDelete, onSuccess, onError }) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: () => TestJourneyService.deleteJourney(idsToDelete),
            onSuccess: (data) => {
                queryClient.invalidateQueries([journeysQueryKeys.journeyList, projectId]);
                onSuccess?.(data);
            },
            onError: (error) => onError?.(error),
        });
}

export const useArchiveJourneyMutation = ({ projectId, onSuccess, onError }) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, status }) =>
            status === JOURNEY_STATUS.archived.value
                ? TestJourneyService.unarchiveJourney(id)
                : TestJourneyService.archiveJourney(id),
        onSuccess: (data) => {
            queryClient.invalidateQueries([journeysQueryKeys.journeyList, projectId]);
            onSuccess?.(data);
        },
        onError: (error) => onError?.(error),
    });
}

export const useCreateJourneyMutation = ({ projectId, onSuccess, onError }) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ pageId, name }) =>
            TestJourneyService.createJourney({ projectId, pageId, name }),
        onSuccess: (data) => {
            queryClient.invalidateQueries([journeysQueryKeys.journeyList, projectId]);
            onSuccess?.(data);
        },
        onError: (error) => onError?.(error),
    });
}
